import React, { useState } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import { FaCirclePlus, FaCircleMinus  } from "react-icons/fa6";

// UTILS
import {categories} from './utils/categories';
import { buildFaqPageJsonLd } from '../../../../components/seo/structuredData';

const DoubtsSection = styled.section`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 5rem 0;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 4rem 1.5rem;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3.5rem;
`;

const Eyebrow = styled.p`
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-accent-hover);
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 3vw, 2.5rem);
  font-weight: 700;
  color: var(--color-brand-deep);
`;

const AccordionContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const AccordionItem = styled.div`
  margin-bottom: 1rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-border);
  overflow: hidden;
  background: var(--color-white);
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  cursor: pointer;
  border-bottom: ${({ $isActive }) => ($isActive ? '1px solid var(--color-border)' : 'none')};
`;

const AccordionTitle = styled.h3`
  font-family: var(--font-body);
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-ink);
  margin: 0;
`;

const AccordionContent = styled.div`
  padding: ${({ $isActive }) => ($isActive ? '1.5rem' : '0')};
  max-height: ${({ $isActive }) => ($isActive ? '1000px' : '0')};
  overflow: hidden;
  transition: all 0.3s ease;
`;

const AnswerText = styled.p`
  font-family: var(--font-body);
  font-size: 0.95rem;
  color: var(--color-ink-soft);
  line-height: 1.6;
`;

const Doubts = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  const toggleCategory = (category) => {
    setActiveCategory(activeCategory === category ? null : category);
  };

  return (
    <DoubtsSection id="Doubts">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(buildFaqPageJsonLd(categories))}
        </script>
      </Helmet>
      <Header>
        <Eyebrow>Perguntas frequentes</Eyebrow>
        <Title>Restou alguma dúvida?</Title>
      </Header>

      <AccordionContainer>
        {categories.map((category) => {
          const isActive = activeCategory === category.id;
          return (
            <AccordionItem key={category.id}>
              <AccordionHeader
                $isActive={isActive}
                onClick={() => toggleCategory(category.id)}
              >
                <AccordionTitle>{category.title}</AccordionTitle>
                {isActive
                  ? <FaCircleMinus size={22} color='var(--color-accent)' />
                  : <FaCirclePlus size={22} color='var(--color-brand)' />}
              </AccordionHeader>
              <AccordionContent $isActive={isActive}>
                <AnswerText>{category.description}</AnswerText>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </AccordionContainer>
    </DoubtsSection>
  );
};

export default Doubts;
